import { gql } from '@apollo/client'

export const BulkCopyListings = gql`
    mutation startBulkCopyProductListingDetails(
        $input: BulkCopyProductListingDetailInput!
    ) {
        startBulkCopyProductListingDetails(input: $input) {
            instanceId
        }
    }
`
export const BulkMoveListings = gql`
    mutation startBulkMoveProductListingDetails(
        $input: BulkMoveProductListingDetailInput!
    ) {
        startBulkMoveProductListingDetails(input: $input) {
            instanceId
        }
    }
`
export const BulkDeleteListings = gql`
    mutation startBulkDeleteProductListingDetails(
        $input: StartBulkDeleteProductListingDetailsInput!
    ) {
        startBulkDeleteProductListingDetails(input: $input) {
            instanceId
        }
    }
`
